/** @format */

import CloseIcon from '@mui/icons-material/Close';
import { Alert, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import CircularLoader from '../../../common/loaders/circularLoader';
import { sessions } from '../../../common/localstorage/SessionStorage';
import { sendEmailSaveApplicationThunk } from '../ApplicantSlice';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

interface Props {
  isSaveAndClose: boolean;
  message: string;
  status: string;
}
export default function SavedApplicationPopUp({
  isSaveAndClose,
  message,
  status,
}: Props) {
  const [open, setOpen] = React.useState(false);
  const [isClosingSession, setIsClosingSession] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (isSaveAndClose || message) {
      setOpen(true);
    }
  }, [isSaveAndClose, message]);
  const handleClose = () => {
    if (isClosingSession) {
      return;
    }
    setIsClosingSession(true);
    dispatch(sendEmailSaveApplicationThunk()).finally(() => {
      sessions.removeToken();
      setOpen(false);
      navigate('/');
      window.location.reload();
    });
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby='alert-dialog-slide-description'>
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 1,
          }}>
          Save and Close Application
          <IconButton
            aria-label='close application'
            onClick={handleClose}
            disabled={isClosingSession || status === 'loading'}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-slide-description'>
            <CircularLoader status={status} />
            {message && (
              <Alert color='success' variant='standard'>
                {message}
              </Alert>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={status === 'loading' || isClosingSession}
            onClick={handleClose}>
            Close Application
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
